import React, { Component } from 'react'

import { LeftArrow, RightArrow, StyledSlider } from './styles'
import Card from './components/Card'
import music from './music'

const handleKeyDown = ({ e, code, onClick }) => {
  if (e.keyCode === code) {
    onClick()
  }
  if (e.keyCode === 13) {
    onClick()
  }
}

const PrevArrow = props => {
  const { style, onClick } = props
  return (
    <div
      className="slick-arrow"
      style={{ ...style, display: 'block' }}
      onClick={onClick}
      role="button"
      tabIndex="0"
      onKeyDown={e => handleKeyDown({ e, code: 37, onClick })}
    >
      <LeftArrow>&#9001;</LeftArrow>
    </div>
  )
}

const NextArrow = props => {
  const { style, onClick } = props
  return (
    <div
      className="slick-arrow"
      style={{ ...style, display: 'block' }}
      onClick={onClick}
      role="button"
      tabIndex="0"
      onKeyDown={e => handleKeyDown({ e, code: 39, onClick })}
    >
      <RightArrow>&#9002;</RightArrow>
    </div>
  )
}

class MusicCarousel extends Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />
    }
    return (
      <div
        width="100%"
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '75vh',
          width: '80%'
        }}
      >
        <StyledSlider {...settings}>
          {music.map(({ title, subtitle, description, url }) => (
            <Card
              title={title}
              key={title}
              subtitle={subtitle}
              description={description}
              url={url}
            />
          ))}
        </StyledSlider>
      </div>
    )
  }
}

export default MusicCarousel



// WEBPACK FOOTER //
// ./src/containers/Music/components/MusicCarousel/index.js